import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=32415a33&"
import script from "./BaseSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports